
import { SetupContext } from 'vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import PreviewPairData from '@/components/block/PreviewPairData.vue'
import Alert from '@/components/elements/Alert.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import ApplyHotelAbstract from '@/components/block/ApplyHotelAbstract.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { useStore } from 'vuex'
import { getAddressPreviewHtml } from '@/utils/commonMethods'
import prefectures from '../../../public/json/prefectures.json'

export default {
  name: 'DocumentRequestConfirm',

  components: {
    Button,
    HeadingLv3,
    PreviewPairData,
    Alert,
    GoalButtons,
    ApplyHotelAbstract
  },

  props: {
    state: {
      type: Object,
      require: true
    },
    hospitalInfo: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => ({})
    },
    notEnterdData: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props: any, context: SetupContext) {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    // 入力ページ経由じゃない場合は弾く
    if (!props.state.isLandingInput) {
      router.replace('/500')
    }

    // ページの更新をしようとした時に確認ダイアログを表示
    window.onbeforeunload = function(e: any) {
      e.returnValue =
        'このページを再読み込みしますか？行った変更が保存されない可能性があります。'
    }

    // ページ遷移時に確認ダイアログ解除
    onBeforeRouteLeave((to, from) => {
      window.onbeforeunload = null
    })

    // 申し込みフローの更新
    context.emit('update-flow', 2)

    const submitForm = () => {
      store.commit('showLoading')
      const paramsIds: any = route.params.id
      const ids = paramsIds.split('_')
      const params: any = {
        ids: ids.map((id: string) => {
          return { hospital_id: id }
        }),
        note: props.data.contents.note.content
      }

      if (!props.data.user.address) {
        params.zip = props.notEnterdData.zip
        params.prefecture = props.notEnterdData.prefecture
        params.city = props.notEnterdData.city
        params.town = props.notEnterdData.town
      }

      if (!props.data.user.tel.content) {
        params.tel = props.notEnterdData.tel
      }

      if (!props.data.user.address_vacation) {
        if (props.notEnterdData.vacation_flg) {
          params.vacation_flg = true
        } else {
          params.zip_vacation = props.notEnterdData.zip_vacation
          params.prefecture_vacation = props.notEnterdData.prefecture_vacation
          params.city_vacation = props.notEnterdData.city_vacation
          params.town_vacation = props.notEnterdData.town_vacation
          params.vacation_flg = false
        }
      }

      const ajax = axiosSetting('app', 'action')
      ajax
        .post('/api/v1/request_entry', params)
        .then((res) => {
          router.push({
            path: `/document_request/${route.params.id}/thanks`
          })
          store.dispatch('getUserInfo')
        })
        .catch((err: any) => {
          if (err.response.status === 422) {
            context.emit('catch-error', err.response.data.err_msg)
            router.go(-1)
            return
          }
          store.commit('closeLoading')
          store.commit('showSystemError', 'modal')
        })
        .then(() => {
          store.commit('closeLoading')
        })
    }

    return {
      submitForm,
      getAddressPreviewHtml,
      prefectures
    }
  }
}
